import TweenOne from 'rc-tween-one';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as ApprovedIcon } from 'assets/svgs/approved-seal.svg';

const Approved = styled(ApprovedIcon)`
  transform: rotate(-30deg);
`;
const ApprovedSealWrapper = styled.div<{ top: number; right: number }>`
  position: fixed;
  right: 40px;
  z-index: 1010;
  top: ${({ top }) => `${top}px`};
  right: ${({ right }) => `${right}px`};
`;

export const ApprovedSeal: FC<{
  top: number;
  right: number;
  className?: string;
}> = ({ top, right, className }) => (
  <ApprovedSealWrapper
    data-cy="timesheets.approval.success"
    className={className}
    top={top}
    right={right}
  >
    <TweenOne
      animation={{
        scale: 1,
        opacity: 1,
        duration: 500,
        ease: 'easeInOutQuint',
      }}
      style={{ transform: 'scale(200%)', opacity: '0' }}
    >
      <Approved />
    </TweenOne>
  </ApprovedSealWrapper>
);
